var _style, _path, _path2, _rect, _rect2, _path3, _polygon, _rect3, _path4, _g, _path5, _g2, _g3, _g4, _g5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _polygon2, _path16, _path17, _path18, _path19, _path20, _polygon3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg17(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1803px",
    height: "1551.3px",
    viewBox: "0 0 1803 1551.3",
    style: {
      enableBackground: "new 0 0 1803 1551.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#7A78F4;}\n\t.st1{fill:#5143D9;}\n\t.st2{fill:url(#SVGID_1_);}\n\t.st3{fill:#FFFFFF;}\n\t.st4{opacity:0.34;fill:#FFFFFF;}\n\t.st5{fill:#C0DDEE;}\n\t.st6{fill:url(#SVGID_2_);}\n\t.st7{fill:#2DB36F;}\n\t.st8{fill:#229958;}\n\t.st9{opacity:0.14;fill:#FFFFFF;}\n\t.st10{fill:#D96F25;}\n\t.st11{fill:#5BC2EF;}\n\t.st12{fill:#F1F3E5;}\n\t.st13{fill:#3598C4;}\n\t.st14{fill:#FFAE1E;}\n\t.st15{fill:#F9AB34;}\n\t.st16{fill:#A5DAEF;}\n\t.st17{fill:#FFFFFD;}\n\t.st18{fill:#EDA785;}\n\t.st19{fill:url(#SVGID_3_);}\n\t.st20{fill:#FEC7A8;}\n\t.st21{fill:url(#SVGID_4_);}\n\t.st22{fill:url(#SVGID_5_);}\n\t.st23{fill:url(#SVGID_6_);}\n\t.st24{fill:#D57751;}\n\t.st25{fill:#1F2B45;}\n\t.st26{opacity:0.61;fill:url(#SVGID_7_);}\n\t.st27{fill:#E2997D;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M753.2,942.2l442.7-0.4c23,0,41.6-18.6,41.6-41.5l-0.8-857.8c0-23.5-19.2-42.5-42.8-42.5L753.4,0.4 c-23.6,0-42.7,19.1-42.7,42.5l0.8,857.8C711.5,923.7,730.2,942.2,753.2,942.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M764.7,933.8l426.8-0.4c22.2,0,40.2-18.1,40.2-40.3L1231,57c0-22.8-18.5-41.3-41.4-41.3l-424.7,0.4 c-22.8,0-41.3,18.5-41.3,41.4l0.8,836.1C724.4,915.8,742.5,933.8,764.7,933.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -3853.2297,
    y1: 104.1122,
    x2: -3853.2297,
    y2: 829.3558,
    gradientTransform: "matrix(-1 0 0 1 -2876.8501 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDFDFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08183694,
    style: {
      stopColor: "#F1FAFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3025,
    style: {
      stopColor: "#D6F4FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5275,
    style: {
      stopColor: "#C3F0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#B8EDFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B4ECFF"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 761.9,
    y: 104.3,
    className: "st2",
    width: 429,
    height: 724.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 888.7,
    y: 60.9,
    className: "st3",
    width: 171.2,
    height: 12.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M930.9,906.9l101.1-0.1c4.2,0,7.6-3.4,7.6-7.7l0-12.9c0-4.2-3.4-7.7-7.7-7.6l-101.1,0.1 c-4.2,0-7.6,3.4-7.6,7.7l0,12.9C923.2,903.5,926.7,906.9,930.9,906.9z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "761.6,152.5 1191.1,736.3 1191.2,828.9 762.2,829.4  "
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 761.6,
    y: 104.3,
    className: "st5",
    width: 429,
    height: 36
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 974.0893,
    y1: 537.1363,
    x2: 974.0893,
    y2: 180.2986
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDFDFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.301,
    style: {
      stopColor: "#FAFCFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5129,
    style: {
      stopColor: "#F1FAFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6973,
    style: {
      stopColor: "#E1F7FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8652,
    style: {
      stopColor: "#CCF2FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B4ECFF"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1108,537.1H840.2c-29.9,0-54.1-24.2-54.1-54.1V234.4c0-29.9,24.2-54.1,54.1-54.1H1108 c29.9,0,54.1,24.2,54.1,54.1V483C1162.1,512.9,1137.9,537.1,1108,537.1z"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1128,404.5c0,11.7-5.9,21.3-13.1,21.3s-13.1-9.5-13.1-21.3s5.9-21.3,13.1-21.3S1128,392.7,1128,404.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1114.9,383.2c0.5,0,0.9,0,1.4,0.1c-6.6,1.1-11.7,10.2-11.7,21.1c0,11,5.1,20,11.7,21.1 c-0.5,0.1-0.9,0.1-1.4,0.1c-7.3,0-13.1-9.5-13.1-21.3S1107.6,383.2,1114.9,383.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1126.2,404.5c0-1.7-0.1-3.4-0.3-4.9c-0.4,0.3-0.9,0.5-1.4,0.5c-1.3,0-2.4-1.2-2.4-2.8 c0-1.5,1.1-2.8,2.4-2.8c0.1,0,0.2,0,0.3,0c-1.9-6.5-5.6-11-10.4-11.3c0.1,0,0.3,0,0.4,0c7.3,0,13.1,9.5,13.1,21.3 s-5.9,21.3-13.1,21.3c-0.1,0-0.3,0-0.4,0C1121.4,425.3,1126.2,416,1126.2,404.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1107.2,415.5l0.4-0.5c0.3-0.4,0.9-0.5,1.3-0.1l2.9,2.5c0.6,0.5,1.6,0.1,1.6-0.7v-5c0-0.5,0.4-1,0.9-1h1 c0.5,0,0.9,0.4,0.9,1v38.7c0,0.5-0.4,1-0.9,1h-1c-0.5,0-0.9-0.4-0.9-1v-27.7c0-0.3-0.1-0.6-0.3-0.7l-5.7-5 C1106.9,416.5,1106.9,415.9,1107.2,415.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1146.1,408.5c0,10.7-5.4,19.4-12,19.4c-6.6,0-12-8.7-12-19.4c0-10.7,5.4-19.4,12-19.4 C1140.8,389.1,1146.1,397.8,1146.1,408.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1134.2,389.1c0.4,0,0.8,0,1.3,0.1c-6,1-10.7,9.3-10.7,19.3c0,10,4.7,18.3,10.7,19.3 c-0.4,0.1-0.8,0.1-1.3,0.1c-6.6,0-12-8.7-12-19.4C1122.2,397.8,1127.5,389.1,1134.2,389.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1144.5,408.5c0-1.6-0.1-3.1-0.3-4.5c-0.4,0.3-0.8,0.4-1.2,0.4c-1.2,0-2.2-1.1-2.2-2.5 c0-1.4,1-2.5,2.2-2.5c0.1,0,0.2,0,0.3,0c-1.7-5.9-5.1-10-9.5-10.3c0.1,0,0.3,0,0.4,0c6.6,0,12,8.7,12,19.4 c0,10.7-5.4,19.4-12,19.4c-0.1,0-0.3,0-0.4,0C1140.1,427.6,1144.5,419,1144.5,408.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1127.2,418.7l0.3-0.4c0.3-0.4,0.9-0.4,1.2-0.1l2.6,2.3c0.6,0.5,1.4,0.1,1.4-0.7v-4.6 c0-0.5,0.4-0.9,0.9-0.9h0.9c0.5,0,0.9,0.4,0.9,0.9v35.3c0,0.5-0.4,0.9-0.9,0.9h-0.9c-0.5,0-0.9-0.4-0.9-0.9v-25.3 c0-0.3-0.1-0.5-0.3-0.7l-5.2-4.6C1126.9,419.6,1126.9,419,1127.2,418.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "1092.3,262.1 1044.2,262.1 1031.7,274.6 1031.7,450.7 1108,450.7 1108,274.6  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1043.7,
    y: 297.6,
    className: "st12",
    width: 10.2,
    height: 28.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1063.2,
    y: 297.6,
    className: "st12",
    width: 10.2,
    height: 28.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1082.6,
    y: 297.6,
    className: "st12",
    width: 10.2,
    height: 28.4
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1043.7,
    y: 337.6,
    className: "st12",
    width: 10.2,
    height: 28.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1063.2,
    y: 337.6,
    className: "st12",
    width: 10.2,
    height: 28.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1082.6,
    y: 337.6,
    className: "st12",
    width: 10.2,
    height: 28.4
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1043.7,
    y: 377.6,
    className: "st12",
    width: 10.2,
    height: 28.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1063.2,
    y: 377.6,
    className: "st12",
    width: 10.2,
    height: 28.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1082.6,
    y: 377.6,
    className: "st12",
    width: 10.2,
    height: 28.4
  }))))))), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "1033,450.7 1003.1,450.7 1003.8,256.6 1033,272.6  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M820.7,404.5c0,11.7,5.9,21.3,13.1,21.3c7.3,0,13.1-9.5,13.1-21.3s-5.9-21.3-13.1-21.3 C826.6,383.2,820.7,392.7,820.7,404.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M833.8,383.2c-0.5,0-0.9,0-1.4,0.1c6.6,1.1,11.7,10.2,11.7,21.1c0,11-5.1,20-11.7,21.1 c0.5,0.1,0.9,0.1,1.4,0.1c7.3,0,13.1-9.5,13.1-21.3S841.1,383.2,833.8,383.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M822.5,404.5c0-1.7,0.1-3.4,0.3-4.9c0.4,0.3,0.9,0.5,1.4,0.5c1.3,0,2.4-1.2,2.4-2.8 c0-1.5-1.1-2.8-2.4-2.8c-0.1,0-0.2,0-0.3,0c1.9-6.5,5.6-11,10.4-11.3c-0.1,0-0.3,0-0.4,0c-7.3,0-13.1,9.5-13.1,21.3 s5.9,21.3,13.1,21.3c0.1,0,0.3,0,0.4,0C827.2,425.3,822.5,416,822.5,404.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M841.4,415.5l-0.4-0.5c-0.3-0.4-0.9-0.5-1.3-0.1l-2.9,2.5c-0.6,0.5-1.6,0.1-1.6-0.7v-5 c0-0.5-0.4-1-0.9-1h-1c-0.5,0-0.9,0.4-0.9,1v38.7c0,0.5,0.4,1,0.9,1h1c0.5,0,0.9-0.4,0.9-1v-27.7c0-0.3,0.1-0.6,0.3-0.7l5.7-5 C841.7,416.5,841.8,415.9,841.4,415.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M802.5,408.5c0,10.7,5.4,19.4,12,19.4c6.6,0,12-8.7,12-19.4c0-10.7-5.4-19.4-12-19.4 C807.9,389.1,802.5,397.8,802.5,408.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M814.5,389.1c-0.4,0-0.8,0-1.3,0.1c6,1,10.7,9.3,10.7,19.3c0,10-4.7,18.3-10.7,19.3 c0.4,0.1,0.8,0.1,1.3,0.1c6.6,0,12-8.7,12-19.4C826.5,397.8,821.1,389.1,814.5,389.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M804.2,408.5c0-1.6,0.1-3.1,0.3-4.5c0.4,0.3,0.8,0.4,1.2,0.4c1.2,0,2.2-1.1,2.2-2.5c0-1.4-1-2.5-2.2-2.5 c-0.1,0-0.2,0-0.3,0c1.7-5.9,5.1-10,9.5-10.3c-0.1,0-0.3,0-0.4,0c-6.6,0-12,8.7-12,19.4c0,10.7,5.4,19.4,12,19.4 c0.1,0,0.3,0,0.4,0C808.5,427.6,804.2,419,804.2,408.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M821.5,418.7l-0.3-0.4c-0.3-0.4-0.9-0.4-1.2-0.1l-2.6,2.3c-0.6,0.5-1.4,0.1-1.4-0.7v-4.6 c0-0.5-0.4-0.9-0.9-0.9h-0.9c-0.5,0-0.9,0.4-0.9,0.9v35.3c0,0.5,0.4,0.9,0.9,0.9h0.9c0.5,0,0.9-0.4,0.9-0.9v-25.3 c0-0.3,0.1-0.5,0.3-0.7l5.2-4.6C821.8,419.6,821.8,419,821.5,418.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "840.7,285.6 840.7,450.7 861.7,450.7 895,450.7 917,450.7 917,389.6 917,383.3 917,375.9  917,369.6 917,362.2 917,355.9 917,348.5 917,342.2 917,334.8 917,328.5 917,321 917,314.8 917,307.3 917,301.1 917,256.6  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "840.7,450.7 902.9,450.7 902.9,273 840.7,295  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 871.8,
    y: 309.6,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1774.7424 625.09)",
    className: "st3",
    width: 31.1,
    height: 5.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 871.8,
    y: 335.4,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1774.7424 676.786)",
    className: "st3",
    width: 31.1,
    height: 5.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 871.8,
    y: 361.3,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1774.7424 728.4818)",
    className: "st3",
    width: 31.1,
    height: 5.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 871.8,
    y: 387.1,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1774.7424 780.1779)",
    className: "st3",
    width: 31.1,
    height: 5.9
  })), /*#__PURE__*/React.createElement("rect", {
    x: 860.4,
    y: 413.3,
    className: "st13",
    width: 22,
    height: 37.4
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "1003.9,256.6 995.7,256.6 995.7,244.1 985.5,244.1 935.4,244.1 925.3,244.1 925.3,256.6  917,256.6 917.3,450.7 1004.2,450.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 928.4,
    y: 288.6,
    className: "st12",
    width: 15.5,
    height: 43.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 953.1,
    y: 288.6,
    className: "st12",
    width: 15.5,
    height: 43.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 977.7,
    y: 288.6,
    className: "st12",
    width: 15.5,
    height: 43.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 928.4,
    y: 339.9,
    className: "st12",
    width: 15.5,
    height: 43.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 953.1,
    y: 339.9,
    className: "st12",
    width: 15.5,
    height: 43.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 977.7,
    y: 339.9,
    className: "st12",
    width: 15.5,
    height: 43.1
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 943.9,
    y: 408.3,
    className: "st13",
    width: 33.8,
    height: 42.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1018.2,
    y: 301,
    className: "st12",
    width: 9.9,
    height: 5.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1018.2,
    y: 326.6,
    className: "st12",
    width: 9.9,
    height: 5.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1018.2,
    y: 352.3,
    className: "st12",
    width: 9.9,
    height: 5.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1018.2,
    y: 377.9,
    className: "st12",
    width: 9.9,
    height: 5.2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 805.2,
    y: 450.7,
    className: "st13",
    width: 337.9,
    height: 22.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M936.1,271.1v-12.3h2v4.5h6v-4.5h2v12.3h-2v-6h-6v6H936.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M961.6,265c0,0.9-0.2,1.7-0.5,2.5c-0.3,0.8-0.8,1.5-1.4,2.1c-0.6,0.6-1.3,1.1-2.1,1.4 c-0.8,0.3-1.6,0.5-2.5,0.5c-0.9,0-1.7-0.2-2.5-0.5c-0.8-0.3-1.5-0.8-2.1-1.4c-0.6-0.6-1.1-1.3-1.4-2.1 c-0.3-0.8-0.5-1.6-0.5-2.5c0-0.9,0.2-1.7,0.5-2.5c0.3-0.8,0.8-1.5,1.4-2.1c0.6-0.6,1.3-1.1,2.1-1.4c0.8-0.3,1.6-0.5,2.5-0.5 c0.9,0,1.7,0.2,2.5,0.5c0.8,0.3,1.5,0.8,2.1,1.4c0.6,0.6,1.1,1.3,1.4,2.1C961.4,263.3,961.6,264.1,961.6,265z M959.5,265 c0-0.6-0.1-1.2-0.3-1.8c-0.2-0.6-0.6-1.1-1-1.5c-0.4-0.4-0.9-0.8-1.4-1c-0.5-0.2-1.1-0.3-1.7-0.3c-0.6,0-1.2,0.1-1.7,0.3 c-0.5,0.2-1,0.6-1.5,1c-0.4,0.4-0.8,0.9-1,1.5c-0.2,0.6-0.3,1.2-0.3,1.8c0,0.6,0.1,1.2,0.3,1.8c0.2,0.6,0.5,1.1,1,1.5 c0.4,0.4,0.9,0.8,1.5,1c0.5,0.2,1.1,0.3,1.7,0.3c0.6,0,1.2-0.1,1.7-0.3c0.5-0.2,1-0.6,1.5-1c0.4-0.4,0.8-0.9,1-1.5 C959.4,266.2,959.5,265.6,959.5,265z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M967.2,260.5v10.6h-2v-10.6h-3.3v-1.7h8.5v1.7H967.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M972,271.1v-12.3h6.9v1.7H974v3.1h4.9v1.8H974v4h4.9v1.8H972z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M981.1,271.1v-12.3h2v10.5h4.5v1.8H981.1z"
  }))))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1066.5,622.3H881.7c-11.7,0-21.2-9.5-21.2-21.2v-14.5c0-11.7,9.5-21.2,21.2-21.2h184.9 c11.7,0,21.2,9.5,21.2,21.2v14.5C1087.7,612.8,1078.2,622.3,1066.5,622.3z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "894.5,189.6 900.5,201.4 913.8,203.3 904.2,212.5 906.4,225.5 894.5,219.4 882.6,225.5  884.9,212.5 875.3,203.3 888.6,201.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "947.6,189.6 953.5,201.4 966.8,203.3 957.2,212.5 959.5,225.5 947.6,219.4 935.7,225.5 938,212.5  928.3,203.3 941.6,201.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "1000.6,189.6 1006.6,201.4 1019.8,203.3 1010.2,212.5 1012.5,225.5 1000.6,219.4 988.7,225.5  991,212.5 981.4,203.3 994.7,201.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "1053.6,189.6 1059.6,201.4 1072.9,203.3 1063.3,212.5 1065.5,225.5 1053.6,219.4 1041.8,225.5  1044,212.5 1034.4,203.3 1047.7,201.4  "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M850.5,676.5c0-10.9-8.8-19.8-19.8-19.8c-10.9,0-19.8,8.8-19.8,19.8c0,3.9,0.7,5.7,2.4,9.3 c3,6.4,9.7,18.4,16.8,29.1c0,0,12.6-17.1,18-29.2c0.7-1.2,1.2-2.5,1.6-3.9c0.1-0.3,0.2-0.5,0.3-0.8c0.1-0.4,0.2-0.8,0.2-1.1 C850.3,678.8,850.5,677.7,850.5,676.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M842.6,675.9c0,6.6-5.3,11.9-11.9,11.9s-11.9-5.3-11.9-11.9c0-6.6,5.3-11.9,11.9-11.9 S842.6,669.3,842.6,675.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1126.7,696.3h-240c-5.8,0-10.5-4.7-10.5-10.5l0,0c0-5.8,4.7-10.5,10.5-10.5h240c5.8,0,10.5,4.7,10.5,10.5 l0,0C1137.2,691.6,1132.5,696.3,1126.7,696.3z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M857.8,765.4c0,13.6-11,24.7-24.7,24.7c-13.6,0-24.7-11-24.7-24.7c0-13.6,11-24.7,24.7-24.7 C846.8,740.8,857.8,751.8,857.8,765.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M833.1,763.7c4.3,0,7.9-3.5,7.9-7.9c0-4.3-3.5-7.9-7.9-7.9c-4.3,0-7.9,3.5-7.9,7.9 C825.3,760.2,828.8,763.7,833.1,763.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M839,764.7c-1.4,1.6-3.5,2.7-5.9,2.7c-2.4,0-4.5-1-5.9-2.7c-4.3,2.2-7.3,6.6-7.3,11.8v2.8h26.4v-2.8 C846.3,771.4,843.4,766.9,839,764.7z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1129.1,776h-240c-5.8,0-10.5-4.7-10.5-10.5l0,0c0-5.8,4.7-10.5,10.5-10.5h240c5.8,0,10.5,4.7,10.5,10.5 l0,0C1139.7,771.2,1135,776,1129.1,776z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M916.2,610v-29h7.3c2.1,0,3.6,0.1,4.6,0.3c1,0.2,1.8,0.6,2.5,1.1c0.9,0.7,1.6,1.5,2.1,2.6 c0.5,1.1,0.7,2.2,0.7,3.5c0,1.5-0.4,2.8-1.1,3.9c-0.7,1-1.7,1.8-3.1,2.2c1.7,0.3,3,1,4,2.3s1.5,2.9,1.5,4.8 c0,1.2-0.2,2.3-0.6,3.3c-0.4,1.1-1,2-1.7,2.7c-0.8,0.8-1.8,1.4-2.9,1.7c-1.2,0.3-3.1,0.5-5.9,0.5H916.2z M920.8,593.3h1.8 c2.2,0,3.8-0.3,4.8-0.9c0.9-0.6,1.4-1.6,1.4-3.1c0-1.6-0.4-2.7-1.3-3.3c-0.9-0.6-2.5-1-4.9-1h-1.8V593.3z M920.8,606.1h1.6 c1.6,0,2.9-0.1,3.7-0.2c0.8-0.1,1.5-0.4,1.9-0.7c0.6-0.4,1-0.9,1.3-1.5c0.3-0.6,0.5-1.4,0.5-2.1c0-0.9-0.2-1.7-0.6-2.4 c-0.4-0.7-0.9-1.2-1.6-1.6c-0.4-0.2-1-0.4-1.5-0.5c-0.6-0.1-1.3-0.2-2.3-0.2h-1.4h-1.6V606.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M969.2,595.6c0,2.1-0.4,4-1.2,5.8c-0.8,1.8-1.9,3.5-3.4,4.9c-1.5,1.4-3.2,2.5-5,3.3 c-1.9,0.8-3.8,1.1-5.9,1.1c-2.1,0-4.1-0.4-6-1.2c-1.9-0.8-3.6-1.9-5-3.3c-1.5-1.4-2.6-3.1-3.4-4.9c-0.8-1.8-1.1-3.8-1.1-5.9 c0-2.1,0.4-4,1.1-5.9c0.8-1.8,1.9-3.5,3.4-4.9c1.5-1.4,3.2-2.5,5-3.3c1.9-0.8,3.9-1.1,6-1.1c2.1,0,4.1,0.4,5.9,1.1 c1.9,0.8,3.5,1.8,5,3.3c1.5,1.5,2.6,3.1,3.4,5C968.9,591.6,969.2,593.5,969.2,595.6z M964.3,595.6c0-1.5-0.3-2.9-0.8-4.2 c-0.5-1.3-1.3-2.5-2.3-3.5c-1-1-2.1-1.8-3.4-2.3c-1.3-0.5-2.6-0.8-4.1-0.8c-1.4,0-2.8,0.3-4.1,0.8c-1.3,0.5-2.4,1.3-3.4,2.4 c-1,1-1.8,2.2-2.3,3.5c-0.5,1.3-0.8,2.7-0.8,4.2c0,1.5,0.3,2.8,0.8,4.2c0.5,1.3,1.3,2.5,2.3,3.5c1,1,2.1,1.8,3.4,2.4 c1.3,0.5,2.6,0.8,4.1,0.8c1.4,0,2.8-0.3,4-0.8c1.3-0.5,2.4-1.3,3.4-2.4c1-1,1.8-2.2,2.3-3.5C964.1,598.4,964.3,597,964.3,595.6z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1004.3,595.6c0,2.1-0.4,4-1.2,5.8c-0.8,1.8-1.9,3.5-3.4,4.9c-1.5,1.4-3.2,2.5-5,3.3 c-1.9,0.8-3.8,1.1-5.9,1.1c-2.1,0-4.1-0.4-6-1.2c-1.9-0.8-3.6-1.9-5-3.3c-1.5-1.4-2.6-3.1-3.4-4.9c-0.8-1.8-1.1-3.8-1.1-5.9 c0-2.1,0.4-4,1.1-5.9c0.8-1.8,1.9-3.5,3.4-4.9c1.5-1.4,3.2-2.5,5-3.3c1.9-0.8,3.9-1.1,6-1.1c2.1,0,4.1,0.4,5.9,1.1 c1.9,0.8,3.5,1.8,5,3.3c1.5,1.5,2.6,3.1,3.4,5C1003.9,591.6,1004.3,593.5,1004.3,595.6z M999.4,595.6c0-1.5-0.3-2.9-0.8-4.2 c-0.5-1.3-1.3-2.5-2.3-3.5c-1-1-2.1-1.8-3.4-2.3c-1.3-0.5-2.6-0.8-4.1-0.8c-1.4,0-2.8,0.3-4.1,0.8c-1.3,0.5-2.4,1.3-3.4,2.4 c-1,1-1.8,2.2-2.3,3.5c-0.5,1.3-0.8,2.7-0.8,4.2c0,1.5,0.3,2.8,0.8,4.2c0.5,1.3,1.3,2.5,2.3,3.5c1,1,2.1,1.8,3.4,2.4 c1.3,0.5,2.6,0.8,4.1,0.8c1.4,0,2.8-0.3,4-0.8c1.3-0.5,2.4-1.3,3.4-2.4c1-1,1.8-2.2,2.3-3.5C999.2,598.4,999.4,597,999.4,595.6z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1009.7,610v-29h4.7v12l10.4-12h5.8l-11.5,12.9L1032,610h-6.1l-11.5-14.8V610H1009.7z"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M470,892.1c0,0,22.5-37.1,28.1-50.6c5.6-13.5,21.3-158.4,37.1-179.8c15.7-21.3,36-69.7,49.4-105.6 c13.5-36,52.8-85.4,59.6-104.5c6.7-19.1,22.5-76.4,36-76.4c13.5,0,41.6-1.1,51.7,37.1s0,120.2-36,153.9l1.1,7.9l12.4-5.6v185.4 c0,0,30.3,131.5,10.1,174.2c0,0-4.3,12.3,66.6,14.1c75,2,225.3,0,225.3,0s-77.3,91.5-145.9,98.2c-68.5,6.7-130.3,78.7-130.3,78.7 L470,892.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 1209.7317,
    y1: 746.7078,
    x2: 1281.3826,
    y2: 746.7078
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C69C6D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3146,
    style: {
      stopColor: "#C89669"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    style: {
      stopColor: "#CF875D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D57751"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M1231.3,704.5c0,0-17.8,16.3-21.2,40.3c-3.5,24,26.1,58.1,45.9,48c19.8-10.1,28-59.6,24.7-67.4 c-3.3-7.7-17.7-24.8-24.7-26.3C1248.9,697.5,1231.3,704.5,1231.3,704.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1278.3,753.1c-2.8-7.5-7.5-16.7-13.8-20.4c-10-5.8-11.4,3.5-8.6,3.5c2.9,0,17.1,33.4,17.1,33.4 C1275.2,764.3,1277,758.6,1278.3,753.1z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 1231.6982,
    y1: 362.431,
    x2: 1303.9491,
    y2: 362.431
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C69C6D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3146,
    style: {
      stopColor: "#C89669"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    style: {
      stopColor: "#CF875D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D57751"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1231.7,309.6c0,0,64,8.1,71.2,45.3c7.2,37.2-26.6,54.6-35.6,55.8c-9.1,1.2-35.6,4.6-35.6,4.6V309.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 1252.6718,
    y1: 712.6324,
    x2: 1252.6718,
    y2: 562.529
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C69C6D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3146,
    style: {
      stopColor: "#C89669"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    style: {
      stopColor: "#CF875D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D57751"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M1232.2,562.5c0,0,74.8,9.2,65.9,71.1c-8.9,61.9-10.4,71.1-34.6,77.8c-24.2,6.7-67.8-16.7-54.4-61.1 c13.4-44.4,23.1-60.3,23.1-60.3V562.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1285.7,695.1c4-8.5,6.5-21.5,9.7-42.8c-4.6-10.1-13.7-25.3-27.2-25.3c-20.1,0-9.2,19.2-9.2,19.2 C1274.9,649.6,1285.7,695.1,1285.7,695.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 1210.0104,
    y1: 509.1069,
    x2: 1295.36,
    y2: 509.1069
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C69C6D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3146,
    style: {
      stopColor: "#C89669"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    style: {
      stopColor: "#CF875D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D57751"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M1233.7,439.7c0,0,69.2,8.5,61,65.8c-8.2,57.3-9.6,65.8-32,72c-22.4,6.2-62.7-15.5-50.4-56.5 c12.4-41,21.4-55.8,21.4-55.8V439.7z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1283.2,562.4c3.7-7.8,6-19.9,8.9-39.6c-4.3-9.3-12.7-23.4-25.2-23.4c-18.6,0-8.5,17.8-8.5,17.8 C1273.3,520.2,1283.2,562.4,1283.2,562.4z"
  })))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M662.1,437.6c11.7-25.3,12.6-48.3,11-57.9c-11.6,13.8-23.4,56.1-29,71.9C644.2,451.6,647.5,469,662.1,437.6z "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M709.3,568.5l-12.4,5.6c0,0-14.6,73-23,87.1c-8.4,14,33.3,83,35.4,92.7V568.5z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "470,892.1 0,1560.9 332,1560.9 540.6,1560.9 735.2,1119  "
  })), /*#__PURE__*/React.createElement("g", null, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1306,1420.3c0,0-166.3-51.7-201.1-91C1070,1290,954,1172,946.3,1160.7c-7.7-11.2-61.7-119.1-61.7-139.3 c0,0,16.3-31.2,56.2-12.4c23.5,11.1,41.6,33.7,41.6,33.7s-51.7-87.6-67.4-129.2C899.2,872,847.5,764.1,861,739.4 c13.5-24.7,42.7-27,60.7-5.6c18,21.3,92.1,140.5,97.8,155.1c5.6,14.6,58.4,93.3,58.4,93.3s-30.3-76.4-30.3-89.9 c0-13.5,14.6-44.9,46.1-44.9c31.5,0,64,41.6,74.2,71.9c0,0,46.1-40.5,82-28.1c36,12.4,36,12.4,36,12.4s37.1-20.2,71.9-1.1 c34.8,19.1,128.1,203.4,137.1,242.7c9,39.3,59.6,131.5,59.6,131.5L1306,1420.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 884.6152,
    y1: 1147.9335,
    x2: 1071.1115,
    y2: 1147.9335
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C69C6D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3146,
    style: {
      stopColor: "#C89669"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    style: {
      stopColor: "#CF875D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D57751"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M1071.1,1292.8c-0.2-36.7-6.4-91-13.8-110c-10.5-27-56.9-76.4-62.2-94.4c-5.2-18-12.7-45.7-12.7-45.7 s-18.1-22.6-41.6-33.7c-39.9-18.8-56.2,12.4-56.2,12.4c0,20.2,53.9,128.1,61.7,139.3C952.3,1169.4,1023.2,1242.2,1071.1,1292.8z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M955.4,852.3c13.3-0.4,33.8-0.2,43.4-0.1c-24.9-41.4-64.6-103.6-77.1-118.5c-18-21.3-47.2-19.1-60.7,5.6 c-11.8,21.7,26.6,107.5,46.8,156.3l0,0C907.8,895.6,937.4,852.9,955.4,852.3z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M906.9,773.4c17.3-7.6,21.3-19.5,21.9-27c-3.6-5.1-6.6-9.2-8.8-11.7c-16.9-20-44.3-17.9-57,5.3 c-3.4,6.3-2.3,18.4,1.4,33.4C864.5,773.5,880,785.2,906.9,773.4z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M916.1,1069.7c-6.2-17.7-31.5-48.3-31.5-48.3c0,11.4,17.2,50.8,33.6,85 C919.3,1097.6,920.3,1081.8,916.1,1069.7z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "1306,1420.3 1361.7,1560.9 1803,1560.9 1554.3,1276.5  "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg17);
export default __webpack_public_path__ + "static/media/17.fc3b6e174c32f08928c93a84b6cf6eda.svg";
export { ForwardRef as ReactComponent };